import { sharedStockRow } from '@/utils/stockQuoteFeed'
import { quoteNumber } from '@/utils/quoteDisplay'

// Display only. The server's floatPL baseline already includes apportioned
// purchase fees and per-order rounding; never replace contract/account totals.
export function chinaPositions(rows) {
  return (rows || []).map(row => {
    // Do not share the position row itself: quote.marketValue is company market
    // capitalisation, whereas this row's marketValue is the holding value.
    const quote = sharedStockRow({ symbol: row.symbol || row.full_code || row.code, last_px: row.last_px }, 'cn')
    const price = quoteNumber(quote.last_px), previous = quoteNumber(row.last_px)
    if (!(price > 0) || price === previous) return row
    const updated = { ...row, last_px: quote.last_px }
    const quantity = quoteNumber(row.deal_hand)
    if (quantity == null || quantity < 0) return updated
    updated.marketValue = Number((price * quantity).toFixed(2))
    const baseline = quoteNumber(row.floatPL), total = quoteNumber(row.total)
    if (baseline != null && previous > 0) updated.floatPL = Number((baseline + (price - previous) * quantity).toFixed(2))
    else if (total != null && total >= 0) updated.floatPL = Number((price * quantity - total).toFixed(2))
    else updated.floatPL = null
    const displayedCost = quoteNumber(row.chengben)
    // Match stockList's four-place numerator / displayed two-place denominator.
    updated.pl = total != null && total >= 0 && quantity > 0 && displayedCost > 0
      ? (price - Number((total / quantity).toFixed(4))) / displayedCost * 100 : null
    return updated
  })
}
